import startServer from './server'

export default startServer
